






















































































































import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"
import JdsMeridian from "@/design-system/patterns/Meridian/JdsMeridian.vue"
import JdsMeridianItem from "@/design-system/patterns/Meridian/JdsMeridianItem.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdiButton from "@/components/JdiButton.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsMeridianBadge from "@/design-system/patterns/Meridian/JdsMeridianBadge.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiDocs from '@/components/JdiDocs.vue';

@Component({
    components: {
        JdsGlyph,
        JdsMeridianBadge,
        JdiStatus,
        JdiButton, JdsIcon, JdsMeridianItem, JdsMeridian, JdiContent, JdiPreview,
        JdiDocs
    }
})
export default class Meridian extends Vue {
    exampleOpen = true

    toggleSize() {
        this.exampleOpen = !this.exampleOpen
    }
}
